import './App.css';
import JMeterDashboard from './components/JMeterDashboard';

function App() {
  return (
   <JMeterDashboard/>
  );
}

export default App;
